import { Link } from "react-router-dom";
import { useSite, asset } from "@/context/SiteContext";

export const Footer = () => {
  const site = useSite();
  return (
  <footer className="bg-slate-950 text-slate-300 mt-20 border-t border-slate-800" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-8 md:grid-cols-3">
      <div>
        <div className="flex items-center gap-2 mb-3">
          <div className="bg-white rounded-lg p-1.5"><img src={asset(site.logo)} alt="" className="h-9" /></div>
          <span className="font-display font-bold text-lg text-white">{site.site_name_1} <span className="text-sun">{site.site_name_2}</span></span>
        </div>
        <p className="text-sm leading-relaxed text-slate-400">{site.footer_about}</p>
      </div>
      <div className="text-sm space-y-2">
        <div className="font-semibold text-white mb-3">الأقسام</div>
        <Link to="/auctions" className="block hover:text-sun" data-testid="footer-auctions">المزاد العلني</Link>
        <Link to="/sale" className="block hover:text-sun" data-testid="footer-sale">مركبات للبيع</Link>
        <Link to="/rent" className="block hover:text-sun" data-testid="footer-rent">للإيجار</Link>
        <Link to="/jobs" className="block hover:text-sun" data-testid="footer-jobs">وظائف لوجستية</Link>
        <Link to="/invest" className="block hover:text-sun" data-testid="footer-invest">استثمار وشراكة</Link>
      </div>
      <div className="text-sm space-y-2 text-slate-400">
        <div className="font-bold text-white mb-3">الخصوصية</div>
        <p>جميع الإعلانات تخضع لمراجعة الإدارة قبل النشر.</p>
        <p>أرقام التواصل لا تظهر إلا بعد موافقة إدارة الموقع على طلب التواصل.</p>
      </div>
    </div>
    <div className="border-t border-white/10 py-4 text-center text-xs text-slate-500">© 2026 {site.site_name_1} {site.site_name_2}</div>
  </footer>
  );
};
